import React, { useEffect, useState } from "react"
import { useParams, useNavigate } from "react-router-dom"
import API from "../services/api"
import { getUser } from "../utils/storage"
import { getAssetURL } from "../configs/assets"

const PlayerLeaderboard = () => {
  const { challengeId } = useParams()
  const navigate = useNavigate()
  const [data, setData] = useState([])
  const [loading, setLoading] = useState(true)
  const user = getUser()

  useEffect(() => {
    fetchLeaderboard()
    const interval = setInterval(() => {
      fetchLeaderboard()
    }, 5000)
    return () => clearInterval(interval)
  }, [])

  const fetchLeaderboard = async () => {
    try {
      const res = await API.get(`/challenges/leaderboard/${challengeId}`)
      console.log("Player LB response:", res.data)
      if (res.data && res.data.leaderboard && res.data.leaderboard.length > 0) {
        setData(res.data.leaderboard)
      } else {
        setData([])
      }
    } catch (err) {
      console.error("Player LB error:", err.response?.data || err.message)
    } finally {
      setLoading(false)
    }
  }

  const top3 = data.slice(0, 3)
  const remaining = data // User wants all items in the list
  const isMatchCompleted = data.length > 0 && data[0].match_status?.toLowerCase() === "completed";

  return (
    <div className="bg-theme-bg text-theme-text min-h-screen pb-20 font-sans">
      
      {/* 🔝 PREMIUM CENTERED HEADER */}
      <div className="sticky top-0 z-[60] bg-theme-card border-b border-theme-border shadow-theme-sm">
          <div className="flex items-center p-4">
              <button 
                  onClick={() => navigate(-1)} 
                  className="w-10 h-10 flex items-center justify-center bg-theme-bg rounded-xl border border-theme-border text-theme-text transition-all active:scale-95 shadow-theme-sm"
              >
                  <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
                    <path d="M15 18l-6-6 6-6" />
                  </svg>
              </button>
              <div className="flex-1 text-center">
                  <h1 className="font-bold text-[10px] uppercase tracking-[0.2em] text-theme-text-sec">Live Standings</h1>
                  {data.length > 0 && data[0].match_status?.toLowerCase() !== "completed" && (
                      <div className="flex items-center justify-center gap-1.5 mt-0.5">
                          <span className="w-1.5 h-1.5 bg-red-500 rounded-full animate-pulse"></span>
                          <span className="text-[9px] font-bold text-red-500 uppercase tracking-tight">Live Updates</span>
                      </div>
                  )}
              </div>
              <div className="w-10 h-10"></div>
          </div>
      </div>

      <div className="p-4 max-w-lg mx-auto">
      {loading ? (
          <div className="flex flex-col items-center justify-center py-32 gap-4">
              <div className="w-9 h-9 border-2 border-accent border-t-transparent rounded-full animate-spin"></div>
              <p className="text-[10px] font-bold text-theme-text-sec uppercase tracking-widest">Fetching Standings...</p>
          </div>
      ) : data.length === 0 ? (
          <div className="text-center py-32 bg-theme-card rounded-[32px] border border-theme-border mx-4 shadow-theme-sm">
              <div className="text-5xl mb-6 opacity-30">🏆</div>
              <p className="text-theme-text-sec font-bold text-[10px] uppercase tracking-widest px-10">No participants yet</p>
          </div>
      ) : (
          <div className="space-y-8 mt-4">
            
            {/* 👑 MINIMAL WINNER PODIUM */}
            {data.length > 0 && (
            <div className="flex justify-center items-end h-56 relative mb-8 px-4">
                {/* RANK 2 */}
                {top3[1] && (
                    <div className="flex flex-col items-center w-1/3 max-w-[100px] animate-in slide-in-from-bottom duration-500 delay-100">
                        <div className="relative mb-2">
                            <div className="w-14 h-14 rounded-full border-2 border-slate-400 p-1 bg-theme-card shadow-lg overflow-hidden">
                                <img src={getAssetURL(top3[1].user_image) || "/player_placeholder.png"} className="w-full h-full object-cover rounded-full" alt="" />
                            </div>
                            <div className="absolute -bottom-1 -right-1 bg-slate-400 text-theme-bg w-5 h-5 rounded-full flex items-center justify-center font-black text-[10px] border-2 border-theme-bg">2</div>
                        </div>
                        <div className="bg-theme-card w-full h-24 rounded-t-2xl flex flex-col items-center justify-end pb-4 border border-theme-border border-b-0 shadow-xl">
                            <p className="text-[9px] font-black text-theme-text uppercase truncate w-full px-2 text-center">{top3[1].user_fullname || top3[1].username}</p>
                            <span className="text-[8px] font-bold text-theme-text-sec mt-1">{top3[1].prediction} Pred</span>
                        </div>
                    </div>
                )}

                {/* RANK 1 - THE KING */}
                {top3[0] && (
                    <div className="flex flex-col items-center w-1/3 max-w-[120px] relative z-10 animate-in slide-in-from-bottom duration-700">
                        <div className="relative mb-3 scale-110">
                            <div className="w-20 h-20 rounded-full border-4 border-yellow-500 p-1 bg-theme-card shadow-[0_0_20px_rgba(234,179,8,0.3)] overflow-hidden">
                                <img src={getAssetURL(top3[0].user_image) || "/player_placeholder.png"} className="w-full h-full object-cover rounded-full" alt="" />
                            </div>
                            <div className="absolute -bottom-1 -right-1 bg-yellow-500 text-black w-7 h-7 rounded-full flex items-center justify-center font-black text-xs border-4 border-theme-bg">1</div>
                        </div>
                        <div className="bg-gradient-to-b from-yellow-500/10 to-theme-card w-full h-36 rounded-t-3xl flex flex-col items-center justify-end pb-6 border-x border-t border-yellow-500/30 shadow-2xl relative">
                            <p className="text-[11px] font-black text-theme-text uppercase truncate w-full px-2 text-center">{top3[0].user_fullname || top3[0].username}</p>
                            <span className="text-[9px] font-bold text-yellow-500 mt-1">{top3[0].prediction} Pred</span>
                            <span className="text-[10px] bg-yellow-500 text-black px-3 py-1.5 rounded-full font-black mt-3 shadow-lg italic animate-bounce">{top3[0].current_prize}</span>
                        </div>
                    </div>
                )}

                {/* RANK 3 */}
                {top3[2] && (
                    <div className="flex flex-col items-center w-1/3 max-w-[100px] animate-in slide-in-from-bottom duration-500 delay-200">
                        <div className="relative mb-2">
                            <div className="w-14 h-14 rounded-full border-2 border-orange-700 p-1 bg-theme-card shadow-lg overflow-hidden">
                                <img src={getAssetURL(top3[2].user_image) || "/player_placeholder.png"} className="w-full h-full object-cover rounded-full" alt="" />
                            </div>
                            <div className="absolute -bottom-1 -right-1 bg-orange-700 text-theme-bg w-5 h-5 rounded-full flex items-center justify-center font-black text-[10px] border-2 border-theme-bg">3</div>
                        </div>
                        <div className="bg-theme-card w-full h-20 rounded-t-2xl flex flex-col items-center justify-end pb-4 border border-theme-border border-b-0 shadow-xl">
                            <p className="text-[9px] font-black text-theme-text uppercase truncate w-full px-2 text-center">{top3[2].user_fullname || top3[2].username}</p>
                            <span className="text-[8px] font-bold text-theme-text-sec mt-1">{top3[2].prediction} Pred</span>
                        </div>
                    </div>
                )}
            </div>
            )}

            {/* 📂 THE LIST */}
            <div className="space-y-3">
                {/* Table Header */}
                <div className="flex items-center justify-between px-5 mb-1 opacity-40">
                    <div className="flex items-center gap-4">
                        <span className="text-[9px] font-black uppercase tracking-widest w-9 text-center">Rank</span>
                        <span className="text-[9px] font-black uppercase tracking-widest ml-4">Participant</span>
                    </div>
                    <span className="text-[9px] font-black uppercase tracking-widest">Prize</span>
                </div>
                {remaining.map((item, index) => {
                    const isUser = item.user_id === user.id
                    const rank = item.rank || index + 1
                    return (
                        <div 
                            key={index} 
                            className={`relative group overflow-hidden transition-all duration-300 ${isUser ? 'scale-[1.02] z-10' : ''}`}
                        >
                            <div className={`relative flex items-center justify-between p-4 rounded-xl border transition-all duration-300 ${isUser ? 'bg-accent/5 border-accent shadow-theme-lg' : 'bg-theme-card border-theme-border shadow-theme-sm'}`}>
                                <div className="flex items-center gap-4">
                                    <div className="w-9 h-9 rounded-lg bg-theme-bg border border-theme-border flex items-center justify-center font-bold text-[11px] text-theme-text-sec italic shrink-0">
                                        {rank}
                                    </div>
                                    <div>
                                        <h3 className={`font-bold text-xs uppercase tracking-tight transition-colors ${isUser ? 'text-accent' : 'text-theme-text'}`}>
                                            {item.user_fullname || item.username} {isUser && <span className="text-[8px] bg-accent text-white px-1.5 py-0.5 rounded-sm ml-1.5 font-bold uppercase tracking-widest">You</span>}
                                        </h3>
                                        <p className="text-[10px] text-theme-text-sec font-medium uppercase tracking-wider mt-0.5">{item.prediction} Predicted</p>
                                    </div>
                                </div>

                                <div className="text-right">
                                    {item.current_prize !== '-' ? (
                                        <div className="bg-green-500/10 px-4 py-1.5 rounded-full border border-green-500/20">
                                            <span className="text-green-600 font-bold text-xs italic">{item.current_prize}</span>
                                        </div>
                                    ) : (
                                        <span className="text-[9px] font-bold text-theme-text-sec/40 italic uppercase tracking-widest">No Prize</span>
                                    )}
                                </div>
                            </div>
                        </div>
                    )
                })}
            </div>

          </div>
        )}
      </div>
    </div>
  )
}

export default PlayerLeaderboard
